<template>
    <div>
        <div class="text-right">
            <b-button @click="handleAdd" variant="blue" :disabled="!is_loaded_figure_definition">+ 추가하기</b-button>
        </div>
        
        <div v-show="!is_loaded_figure_definition && !load_error" :class="[{'d-flex': !is_loaded_figure_definition }, 'justify-content-center align-items-center bg-light p-3']">
            <p class="mb-0"> 불러오는중 </p>
        </div>
        <div v-if="load_error" class="d-flex flex-column justify-content-center align-items-center bg-light p-3">
            <p class="mb-2 text-danger">{{ load_error }}</p>
            <b-button size="sm" variant="outline-secondary" @click="load">다시 시도</b-button>
        </div>
        <b-table-simple v-show="is_loaded_figure_definition" hover class="rep-table">
            <b-thead>
                <b-tr>
                    <b-td> No.</b-td>
                    <b-td class="w-100"> Figure Definition </b-td>
                    <b-td> 조정 </b-td>
                </b-tr>
            </b-thead>
            <b-tbody>
                <template v-if="!figure_definitions.length">
                    <b-tr>
                        <b-td colspan="3" class="text-center">
                            <i>없음</i>
                        </b-td>
                    </b-tr>
                </template>
                <template v-else>
                    <b-tr v-for="(fd_item, fd_index) in figure_definitions" :key="fd_item.fd_id">
                        <b-td> {{ fd_index + 1 }}. </b-td>
                        <b-td class="text-left py-2">
                            <h6 class="d-inline">{{ fd_item.figure_code }}. {{ fd_item.figure_name }}. {{ fd_item.data_year }}</h6>
                            <b-dropdown class="ml-3" size="sm" menu-class="figure-definitio-list-dropdown-option">
                                <b-dropdown-item v-for="d_item in figure_dictionaries" :key="d_item.id" @click="selectFigure(d_item, fd_index)"> {{ d_item.figure_code }}. {{ d_item.figure_name }} </b-dropdown-item>
                            </b-dropdown>

                            <p class="f-90 mb-0">Value Definition</p>
                            <b-form-textarea v-model="fd_item.figure_formula" class="mb-2"></b-form-textarea>
                            <p class="f-90 mb-0">Unit Definition</p>
                            <b-form-textarea v-model="fd_item.unit_formula" class="mb-2"></b-form-textarea>
                            <p class="f-90 mb-0">Data Year</p>
                            <b-form-input v-model="fd_item.data_year"></b-form-input>
                        </b-td>
                        <b-td> 
                           <b-button size="sm" @click="handleDelete(fd_index)" variant="dark-border">삭제</b-button>
                        </b-td>
                    </b-tr> 
                </template>  
            </b-tbody>
        </b-table-simple>

        <div class="text-right">
            <b-button variant="blue" class="mr-2" @click="handleSave" :disabled="!is_loaded_figure_definition || is_saving">
                <b-spinner v-show="is_saving" small class="mr-1" />저장
            </b-button>
            <b-button variant="dark" @click="$emit('click-cancel')" :disabled="is_saving">취소</b-button>
        </div> 
    </div>
</template>
<script>
import { getErrorMessage } from '@core/utils/api/errorMessage';

export default {
    name: "EditingFigureDefinition",
    props: {
        sub_code: {
            type: String,
            default: ''
        },
        sub_type: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            is_loaded_figure_definition: false,
            load_error: '',
            original_rows: new Map(),
            is_saving: false,
            figure_definitions: [],
            //{ fd_id, figure_code, figure_formula, unit_formula, data_year } 가 있는 배열, 해당 sub_init 관련

            figure_dictionaries: []
            //{ id, figure_code, figure_name, standard_unit } 이 있는 배열. 모든 figure
        }
    },
    async created() {
        await this.load()
    },
    beforeDestroy() {
        this.is_loaded_figure_definition = false
    },
    methods: {
        async load() {
            this.is_loaded_figure_definition = false
            this.load_error = ''
            try {
                await this.readFigureUniverse()
                await this.readFigureDefinitions()
                this.is_loaded_figure_definition = true
            } catch (error) {
                this.load_error = `정량데이터 분석 로직을 불러오지 못했습니다. (${getErrorMessage(error, error && error.message ? error.message : '알 수 없는 오류')})`
            }
        },
        async readFigureUniverse() {
            const response = await this.$axios.get('/read_figure_dictionaries')
            this.figure_dictionaries = []
            response.data.forEach( item => {
                //item: [{ id, figure_code, figure_name, standard_unit }
                this.figure_dictionaries.push(item)
            })
        },
        async readFigureDefinitions() {
            const response = await this.$axios.get('/read_figure_definitions', {
                params: { sub_code: this.sub_code }
            })
            
            this.figure_definitions = []
            this.original_rows = new Map()
            if (response.data.code !== 'fail') {
                response.data.value.forEach(item => {
                    this.figure_definitions.push(item)
                    this.original_rows.set(item, JSON.stringify(item))
                })
            }
        },
        selectFigure(item,fd_idx){
            let selected_dfn = this.figure_definitions[fd_idx]
            selected_dfn.fd_id = item.id
            selected_dfn.figure_code = item.figure_code
            selected_dfn.figure_name = item.figure_name
            this.figure_definitions.splice(fd_idx, selected_dfn)
        },
        async handleSave () {
            const isInvalid = fd => !fd.figure_code || !String(fd.figure_formula || '').trim() || !/^\d{4}$/.test(String(fd.data_year))
            // 서버에서 읽은 뒤 그대로인 기존 행은 막지 않고, 새로 추가/수정한 행만 검증한다
            const isUntouched = fd => this.original_rows.get(fd) === JSON.stringify(fd)
            const legacy_count = this.figure_definitions.filter(fd => isUntouched(fd) && isInvalid(fd)).length
            const invalid_idx = this.figure_definitions.findIndex(fd => !isUntouched(fd) && isInvalid(fd))
            if (legacy_count) {
                this.$EventBus.$emit('toast-warning', '기존 항목 확인', `기존 ${legacy_count}개 항목에 비어 있거나 올바르지 않은 값이 있습니다(수정하지 않아 저장은 진행합니다).`)
            }
            if (invalid_idx > -1) {
                return this.$EventBus.$emit('toast-warning', '입력 확인', `${invalid_idx + 1}번 항목: Figure 를 선택하고, Value Definition 과 4자리 Data Year 를 입력해야 합니다.`)
            }
            try {
                this.is_saving = true
                await this.saveFigureDefinitions()
                this.$EventBus.$emit('toast-success','성공','정량데이터 분석로직을 저장하였습니다.')
            } catch (error) {
                this.$EventBus.$emit('toast-failure', '정량데이터 분석로직 저장 실패', getErrorMessage(error, '저장하지 못했습니다. 입력한 내용은 그대로 두었으니 다시 시도해주세요.'))
            } finally {
                this.is_saving = false
            }
        },
        async saveFigureDefinitions () {
            const formData = new FormData()
            formData.append('sub_code', this.sub_code)
            formData.append('figure_definitions', JSON.stringify(this.figure_definitions))

            const response =  await this.$axios.post('/save_figure_definitions', formData)
            console.log(response.data)
        },
        handleAdd(){
            let new_item = {
                figure_code: 0,
                figure_name: '',
                figure_formula: '',
                unit_formula: '',
                data_year: new Date().getFullYear()
            }
            this.figure_definitions.push(new_item)
        },
        async handleDelete(fd_index){
            const fd = this.figure_definitions[fd_index]
            const ok = await this.$showModal({
                type: 'confirm',
                state: 'warning',
                title: '분석 로직 삭제',
                message: `${fd_index + 1}번 항목(${fd.figure_code}. ${fd.figure_name || ''} ${fd.data_year})을 목록에서 삭제합니다. 저장하면 서버에서도 삭제되어 되돌릴 수 없습니다.`
            })
            if (ok) this.figure_definitions.splice(fd_index, 1)
        }
    }
}
</script>
<style>
.figure-definitio-list-dropdown-option {
    height: 75vh;
    max-height: 700px;
    min-height: 200px;
    overflow: auto;
}

</style>
